'use client';

import React from 'react';
import { RefreshCw } from 'lucide-react';
import LegalDocumentBody from '@/components/LegalDocumentBody';

export default function RefundPolicyContent() {
  return (
    <LegalDocumentBody
      pageId="refund"
      icon={<RefreshCw size={13} className="text-primary" />}
      calloutIcon={<RefreshCw size={15} className="text-amber-400 shrink-0 mt-0.5" />}
      footerLinks={[
        { href: '/privacy-policy', labelKey: 'privacyLink' },
        { href: '/terms-of-service', labelKey: 'termsLink' },
      ]}
    />
  );
}
